import axiosInstance from "../axiosInstance";
export function isLogedIn() {
    return localStorage.getItem('token');
}


export function logOut(props) {
    axiosInstance.post('/logout')
    .then(response => {
        localStorage.removeItem('token');
        props.history.push("/login");
    })
    .catch(err => {
        console.log(err);
    })
    
}

export function getUsername() {

}

export function getRole() {
    return 1
}


export function make_select_data(data) {
    var array = [];
    data.forEach(function (element) {
        array.push({
            value: element.id,
            label: element.display_name
        })
    });
    return array;
}

export function containsPermission(permissions, permission) {
    for (let i = 0; i < permissions.length; i++) {
        let element = permissions[i];
        if (element.name === permission) {
            return true;
        }
    }
    return false;
}

export function generateErrorMessage(errors){
    let message = "";
    let keys = Object.keys(errors);
    keys.forEach(element => {
        message = message + errors[element]+ '\n';
    });
    return message;
}